// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__8JBTO","MapContainer":"style_MapContainer__iu_OG","region":"style_region__o2DvK"};